module.exports = __webpack_public_path__ + "static/media/segments.b9481e3d.svg";